// returns an obj with the minutes/seconds for a duration
export default function (duration: number) {
  const minutes = Math.floor(duration / 60)
  const seconds = duration - minutes * 60

  return { minutes, seconds }
}
